function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ExclamationCircleIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.2 27.3",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.6.2C6.1.2.1 6.2.1 13.7s6 13.5 13.5 13.5 13.5-6 13.5-13.5S21 .2 13.6.2zm0 24c-5.8 0-10.5-4.7-10.5-10.5S7.8 3.2 13.6 3.2s10.5 4.7 10.5 10.5-4.7 10.5-10.5 10.5zm0-17c-.8 0-1.5.7-1.5 1.5v5.1c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V8.7c0-.9-.7-1.5-1.5-1.5zm0 10c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5z"
  }));
};
export default ExclamationCircleIcon;